export default "__VITE_ASSET__Cc5sTXTs__"